module.exports = __webpack_public_path__ + "img/bgs2_m.8d0a24f1.png";